import { Mixins, Component, Prop } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'
import DialogTemplate from '@/_components/dialog/template/template.vue'

@Component({
    inheritAttrs: false,
    name: 'confirm-delete',
    components: { DialogTemplate },
})
export default class ConfirmDelete extends Mixins<MixinInterface>() {
    @Prop({ required: true }) props!: any

    get deleted(): string {
        return this.props.deleted
    }

    get name(): string {
        return this.props.name
    }

    get type(): string {
        return this.props.type
    }

    get needConfirm(): boolean {
        return this.props.needConfirm
    }

    testText = ''

    get testPassed() {
        return this.needConfirm && !this.deleted
            ? this.testText.toString().toLowerCase() == this.name.toString().toLowerCase()
            : true
    }
}
